// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer--footer--3N4oY","footer__content":"Footer--footer__content--3FUJz","footer__list":"Footer--footer__list--3m4JX","footer__item":"Footer--footer__item--31NlX"};